import React from "react";
import { Link } from "react-router-dom";
const CentromericCopyNumberAssays = () => {
  return (
    <div className="row">
      <div className="col align-self-center">
        <Link to="/digital-assays/featured-content/centromeric-copy-number-reference-assays">
          <h4> Centromeric Copy Number Assays​</h4>
          <p>
            Review validated copy number reference assays located in the
            centromeric region of each chromosome (both p and q arms)​
          </p>
        </Link>
      </div>
    </div>
  );
};

export default CentromericCopyNumberAssays;
